import type { Dispatch } from 'redux';
import { stop as stopCommitting } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/domain/update-jira/commit/actions.tsx';
import type { DispatchProps } from './types.tsx';

export const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
	stopCommitting: () => {
		dispatch(stopCommitting());
	},
});
